export default {
  "source": {
    "filter": "Filter sources",
    "fivetran_pause_after_trial": "This connection will be automatically paused on {date}.",
    "fivetran_connection_paused": "This connection was paused on {date}. Administrators can resume the connection at any time from the connections page."
  }
};
